declare global {
  interface Window {
    iFrameResizer: any; // eslint-disable-line
  }
}

/**
 * resizeIframe() must be triggered in the iframe context
 * to ensure that the iframe content is fully displayed.
 */
export function resizeIFrame() {
  if (window.iFrameResizer) {
    setTimeout(() => {
      window.iFrameResizer.resize();
    }, 1000);
  }
}
